module.exports = function() {
  return new Worker(__webpack_public_path__ + "14e5aa0b2ec0756f0d06.worker.js");
};